// import axios from 'axios'
import { post, put, get, remove } from '@/api/api'

export const actions = {
  fetchBannieres({ commit }) {
    // const { pageNumber = 0, pageSize = state.pagination.size } = params
    return get(`/canal/banniere`).then(({ data }) => {
      commit("addBannieres", data);
    });
  },
  async fetchBannieresPage({ commit }, params = {}) {
    const { page = 0, size = 10, sort = '' } = params;
    const queryParams = new URLSearchParams({
      page,
      size,
      sort,
    }).toString();

    let { data } = await get(`/canal/banniere/page?${queryParams}`);
    commit("addBannieresPage", data)
    return data;
  },
  createBanniere({ commit }, banniere) {
    return post("/canal/banniere", banniere).then(({ data }) => {
      commit("addBanniere", data);
    });
  },
  updateBanniere({ commit }, banniere) {
    return put(`/canal/banniere/${banniere.id}`, banniere).then(({ data }) => {
      commit("replaceBanniere", data);
    });
  },
  createOrUpdateBanniere({ dispatch }, banniere) {
    if (banniere.id !== undefined) {
      return dispatch('updateBanniere', banniere)
    } else {
      return dispatch('createBanniere', banniere)
    }
  },
  deteteBanniere({ commit }, banniere) {
    return remove(`/canal/banniere/${banniere.id}`)
      .then(({ data }) => {

      })
  },
  selectBanniere({ commit }, banniere) {
    commit('setBanniere', banniere)
  }
}
